import { ContractualTerm } from '../contractual-terms/contractual-term.type';
import { PlanDistribution } from '../plan-distributions/plan-distribution.types';

export enum PLAN_KEYS {
  MULTIASSISTENCIA = 'multi',
  BEM_SEGURO = 'bem-seguro',
  BEM_ESTAR = 'bem-estar',
  ESSENCIAL = 'essencial',
  NEO = 'neo',
  BEM_FLEX = 'bem-flex',
}

export type Plan = {
  id: number;
  slug: string;
  name: string;
  position: number;
} & PlanAdditionalInfo;

type PlanAdditionalInfo = {
  title?: string;
  basePrice?: number;
  cremationPrice?: number;
  familyTombstonePrice?: number;
  business_unit?: string;
  base_price?: string;
  enrollment?: {
    price: number;
    discount_percentage: number;
  };
};

export type FilterListPlansParams = {
  source_name?: string;
  is_confirmed?: boolean;
  created_at?: string;
  user_confirmation_status?: boolean;
  admin_validation_status?: string;
  admin_validation_outcome?: string;
};

export type ListPlansParams = {
  pageIndex: number;
  pageSize: number;
} & FilterListPlansParams;

export type Pagination = {
  current_page: number;
  next_page: number;
  prev_page: number;
  total_count: number;
  total_pages: number;
};

export type PlanSetup = {
  id?: string;
  slug?: string;
  name: string;
  position: number;
};

export type PlanSetupResponse = {
  plan: PlanSetup;
};

export type ListPlansResponse = {
  plans: PlanSetup[];
  meta: {
    pagination: Pagination;
  };
};

export type PlanVersion = {
  id?: string;
  plan_distribution_id?: string;
  slug?: string;
  plan_distribution?: PlanDistribution;
  plan?: Plan;
};

export type PlanVersionsResponse = {
  plan_versions: PlanVersion[];
};

export type BusinessUnit = {
  id: number;
  slug: string;
  name: string;
};

export type BusinessUnitsResponse = {
  business_units: BusinessUnit[];
};

export type PlansResponse = {
  plan_versions: Plan[];
};

export type PlanResponse = {
  plan_version: Plan;
};

export type PlanTermsResponse = {
  contractual_terms: ContractualTerm[];
};
